import { View } from '../../base/View';
import { ensureElement, handlePrice } from '../../../utils/utils';
import { SETTINGS } from '../../../utils/constants';
export const categoryCheck = {
    другое: 'card__category_other',
    'софт-скил': 'card__category_soft',
    дополнительное: 'card__category_additional',
    кнопка: 'card__category_button',
    'хард-скил': 'card__category_hard',
};
// Общий класс для карточек
export class ProductCardView extends View {
    constructor(container, actions) {
        super(container);
        this._title = ensureElement(SETTINGS.productSettings.title, container);
        this._image = ensureElement(SETTINGS.productSettings.image, container);
        this._button = container.querySelector(SETTINGS.productSettings.button);
        this._category = container.querySelector(SETTINGS.productSettings.category);
        this._price = container.querySelector(SETTINGS.productSettings.price);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            if (this._button)
                this._button.addEventListener('click', actions.onClick);
            else
                container.addEventListener('click', actions.onClick);
        }
    }
    get id() {
        return this.container.dataset.id || '';
    }
    get title() {
        return this._title.textContent || '';
    }
    set id(value) {
        this.container.dataset.id = value;
    }
    set title(value) {
        this._title.textContent = value;
        this._image.alt = value;
    }
    set image(value) {
        this._image.src = value;
    }
    set selected(value) {
        if (!this._button.disabled)
            this._button.disabled = value;
    }
    set price(value) {
        this._price.textContent = value
            ? handlePrice(value) + ' синапсов'
            : 'Бесценно';
        if (this._button && !value)
            this._button.disabled = true;
    }
    set category(value) {
        this._category.textContent = value;
        this._category.classList.add(categoryCheck[value]);
    }
}
// основа для карточки в main page
export class ProductItemView extends ProductCardView {
    constructor(container, actions) {
        super(container, actions);
    }
}
// основа для карточки в мадалке превьюшки
export class ProductItemModalView extends ProductCardView {
    constructor(container, actions) {
        super(container, actions);
        this._description = container.querySelector(SETTINGS.productSettings.text);
    }
    set description(value) {
        this._description.textContent = value;
    }
}
